<template>
  <div class="flex-column" style="width: 100%;padding-bottom: 30px">
    <div style="color: black;font-size: 18px;padding-bottom: 10px;padding-top: 15px">用户信息</div>
    <div style="width: 100%;height:1px;border-bottom: 1px solid #f5f7f9"></div>
    <div class="flex" style="width: 100%">
      <div style="width: 150px;text-align: center;flex-shrink: 0">
        <img-upload @uploadSuccess="uploadImageSuccess" picurl="common/logo/">
          <img :src="imgPath? imgPath:require('../../assets/common/ic_youxiang.png')" alt=""
               slot="tip"
               style="width: 100px;height: 100px;border-radius: 50%;margin-top: 10px">
        </img-upload>
        <div style="margin-top: 10px">{{userName}}</div>
      </div>
      <div class="flex-column" style="flex-grow: 1;margin-left: 20px">
        <div style="display: flex;align-items: center;margin: 15px 30px;width: 100%;">
          <div style="flex-shrink: 0;width: 60px">昵称:</div>
          <Input style="width: 300px;" v-model="userName"></Input>
        </div>
        <div style="display: flex;align-items: center;margin: 15px 30px;width: 100%;">
          <div style="flex-shrink: 0;width: 60px">性别:</div>
          <RadioGroup v-model="radio">
            <Radio :label="1">男</Radio>
            <Radio :label="2" style="margin-left: 10px">女</Radio>
          </RadioGroup>
        </div>
        <div style="display: flex;align-items: center;margin: 15px 30px;width: 100%;">
          <div style="flex-shrink: 0;width: 60px">手机:</div>
          <Input disabled style="width: 300px;" v-model="phone"></Input>
        </div>
      </div>
    </div>
    <Button @click="onUserEditClick" style="width: 100px;margin-top: 20px;margin-left: auto;margin-right: auto"
            type="primary">确定
    </Button>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import ImgUpload from '@/components/common/ImgUpload'

export default {
  name: 'UserEdit',
  components: {
    ImgUpload,
  },
  props: {
    showinfo: Boolean
  },
  watch: {
    showinfo (newValue, oldValue) {
      if (newValue) {
        this.getUserInfo().then(res => {
          this.imgPath = res.logo
          let name = res.name
          this.userName = name
          if (res.phone) {
            this.phone = res.phone.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
          } else {
            this.phone = ''
          }
          this.radio = res.gender || 0
        })
      } else {
        this.imgPath = ''
        this.userName = ''
        this.phone = ''
        this.radio = 0
      }
    }
  },
  data () {
    return {
      imgPath: '',
      userName: '',
      radio: 0,
      phone: ''
    }
  },
  methods: {
    uploadImageSuccess (data) {
      let res = data[0]
      this.imgPath = res.url
    },
    onUserEditClick () {
      let params = {}
      params.name = this.userName
      params.icon = this.imgPath
      if (this.radio === 1 || this.radio === 2) {
        params.gender = this.radio
      }
      this.editUserInfo(params).then(res => {
        if (res.code === 0) {
          this.getUserInfo()
          this.$emit('userconfig')
        }
      })
    },
    ...mapActions([
      'getUserInfo',
      'editUserInfo'
    ])
  }
}
</script>

<style scoped>
  fieldset[disabled] .ivu-input {
    background-color: white;
    color: #515a6e;
  }

  div >>> .ivu-select-disabled .ivu-select-selection {
    background-color: white;
    color: #515a6e;
  }

  div >>> .ivu-input[disabled] {
    background-color: white;
    color: #515a6e;
  }
</style>
